import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "ya-warningdialog",
  templateUrl: "./warningDialog.component.html",
  styleUrls: ["./warningDialog.component.scss"]
})
export class WarningdialogComponent implements OnInit {

  constructor(public bottomSheetRef: MatBottomSheetRef<WarningdialogComponent, boolean>
    , private _coreLanguageService: CoreLanguageService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public warningObg: any) {
  }

  public emphasizedText = false;

  ngOnInit() {
    if (this.warningObg && this.warningObg.emphasizedText) {
      this.emphasizedText = this.warningObg.emphasizedText;
    }
  }

  public evaluateLanguageString(s: string | (() => string) | boolean): string {
    const me = this;
    if (typeof s === "string") {
      return me._coreLanguageService.value(s);
    } else if (typeof s === "function") {
      return s();
    }
  }

  public closeBottomSheet() {
    const me = this;
    // true to open another modal after closing this one
    me.bottomSheetRef.dismiss(true);
    //! todo es muss bei jeglichem schliessen ein true returnen, bzw. es darf gar kein close 'X' button (ya-bottomsheetclosebottom) oben rechts haben
  }
}
